(function () {
  if (window.amcDiyVariantGateBound) return;
  window.amcDiyVariantGateBound = true;

  var proceeding = false;
  var pendingAction = 'atc';
  var lastFocus = null;
  var i18n = null;

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function cssEscape(value) {
    var text = String(value || '');
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(text);
    return text.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function getRoot() {
    return qs(document, '[data-amc-diy-variant-gate-root]');
  }

  function getPicker(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-amc-diy-variant-picker], .variant-selects-main')) {
      return scope;
    }
    return qs(scope, '[data-amc-diy-variant-picker], .variant-selects-main');
  }

  function getGate() {
    return qs(document, '[data-amc-diy-variant-gate]');
  }

  function getSectionId() {
    var root = getRoot();
    return (root && root.getAttribute('data-amc-diy-section')) || (getGate() && getGate().getAttribute('data-section-id')) || '';
  }

  function readI18n() {
    if (i18n) return i18n;
    var node = qs(document, '[data-amc-diy-gate-i18n]');
    try {
      i18n = node ? JSON.parse(node.textContent) : {};
    } catch (err) {
      i18n = {};
    }
    return i18n;
  }

  function isHiddenGroup(el) {
    if (!el || el.classList.contains('hidden')) return true;
    if (el.getAttribute('aria-hidden') === 'true') return true;
    return false;
  }

  function visibleGroups(picker) {
    if (!picker) return [];
    return qsa(picker, '[data-option-name]').filter(function (el) {
      return !isHiddenGroup(el);
    });
  }

  function groupName(el) {
    var title = qs(el, '.amc-diy-style-picker__title');
    if (title) {
      return String(title.textContent || '')
        .replace(/^choose your\s+/i, '')
        .replace(/\s+/g, ' ')
        .trim();
    }
    var label = qs(el, 'legend, label');
    var text = label ? label.textContent : el.getAttribute('data-option-name');
    return String(text || '')
      .replace(/:\s*[\s\S]*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isGroupSelected(el) {
    if (qs(el, 'input[type="radio"]:checked')) return true;
    var select = qs(el, 'select');
    return !!(select && String(select.value || '').trim());
  }

  function missingGroups(picker) {
    return visibleGroups(picker).filter(function (el) {
      return !isGroupSelected(el);
    });
  }

  function needsSelection(root) {
    return missingGroups(getPicker(root)).length > 0;
  }

  function formatOptionList(names, andWord) {
    var clean = names
      .map(function (name) {
        return String(name || '').trim().toLowerCase();
      })
      .filter(Boolean);
    if (!clean.length) return '';
    if (clean.length === 1) return clean[0];
    if (clean.length === 2) return clean[0] + ' ' + andWord + ' ' + clean[1];
    return clean.slice(0, -1).join(', ') + ', ' + andWord + ' ' + clean[clean.length - 1];
  }

  function interpolate(template, option) {
    return String(template || '').replace(/__OPTION__/g, option);
  }

  function collectGroupOptions(el) {
    var options = [];
    qsa(el, 'input[type="radio"]').forEach(function (radio) {
      var label = qs(el, 'label[for="' + cssEscape(radio.id) + '"]');
      options.push({
        id: radio.id,
        value: radio.value,
        label: ((label && (label.querySelector('.amc-diy-style-card__name') || label).textContent) || radio.value || '').trim(),
        available: radio.dataset.available !== 'false' && !radio.classList.contains('disabled'),
        selected: !!radio.checked,
        image: radio.getAttribute('data-preview-image') || '',
        type: 'radio',
      });
    });
    if (options.length) return options;

    var select = qs(el, 'select');
    if (!select) return options;
    Array.prototype.forEach.call(select.options, function (opt) {
      if (!opt.value) return;
      options.push({
        id: select.id,
        value: opt.value,
        label: (opt.textContent || opt.value).trim(),
        available: opt.dataset.available !== 'false',
        selected: !!opt.selected && !!opt.value,
        image: opt.getAttribute('data-preview-image') || '',
        type: 'select',
      });
    });
    return options;
  }

  function applyOption(option) {
    var picker = getPicker();
    if (!picker || !option) return;
    if (option.type === 'radio') {
      var radio = qs(picker, '#' + cssEscape(option.id));
      if (!radio || radio.disabled) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var select = qs(picker, '#' + cssEscape(option.id));
    if (!select) return;
    select.value = option.value;
    Array.prototype.forEach.call(select.options, function (opt) {
      if (opt.value === option.value) opt.setAttribute('selected', 'selected');
      else opt.removeAttribute('selected');
    });
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncVariantIdFromSelection() {
    var picker = getPicker();
    var sectionId = getSectionId();
    var groups = visibleGroups(picker);
    if (groups.length !== 1) return false;
    var checked = qs(groups[0], 'input[type="radio"]:checked');
    if (!checked) return false;
    var script = qs(picker, 'script[data-resource="' + cssEscape(checked.id) + '"]');
    if (!script) return false;
    try {
      var variant = JSON.parse(script.textContent);
      if (!variant || !variant.id) return false;
      [
        '#update-variant-' + sectionId,
        '#update-variant-sticky-' + sectionId,
        '#product-form-' + sectionId + ' input[name="id"]',
        '#product-form-sticky-' + sectionId + ' input[name="id"]',
        '#product-form-installment-' + sectionId + ' input[name="id"]',
      ].forEach(function (sel) {
        qsa(document, sel).forEach(function (input) {
          input.value = String(variant.id);
        });
      });
      return true;
    } catch (err) {
      return false;
    }
  }

  function markResolved(picker, value) {
    if (!picker) return;
    if (value) picker.setAttribute('data-amc-diy-resolved', 'true');
    else picker.removeAttribute('data-amc-diy-resolved');
  }

  function isResolved(picker) {
    if (!picker) return true;
    if (picker.getAttribute('data-amc-diy-resolved') === 'true') return true;
    if (visibleGroups(picker).length === 1 && syncVariantIdFromSelection()) {
      markResolved(picker, true);
      return true;
    }
    return false;
  }

  function waitForResolved(timeout) {
    var picker = getPicker();
    var sectionId = getSectionId();
    return new Promise(function (resolve) {
      if (isResolved(picker)) {
        resolve(true);
        return;
      }
      var done = false;
      var timer;
      function finish() {
        if (done) return;
        done = true;
        if (timer) window.clearTimeout(timer);
        resolve(isResolved(getPicker()));
      }
      document.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, finish, { once: true });
      timer = window.setTimeout(finish, timeout || 1800);
    });
  }

  function syncPayCatcher() {
    qsa(document, '[data-amc-diy-pay-catcher]').forEach(function (catcher) {
      var hide = !needsSelection();
      catcher.hidden = hide;
      catcher.setAttribute('aria-hidden', hide ? 'true' : 'false');
    });
  }

  function updateCopy(gate, picker) {
    var strings = readI18n();
    var names = visibleGroups(picker).map(groupName);
    var option = formatOptionList(names, strings.option_and || 'and');
    var title = option ? interpolate(strings.title, option) : strings.title_fallback;
    var body = option ? interpolate(strings.body, option) : strings.body_fallback;
    var titleEl = qs(gate, '[data-amc-diy-gate-title]');
    var bodyEl = qs(gate, '[data-amc-diy-gate-body]');
    if (titleEl) titleEl.textContent = title;
    if (bodyEl) bodyEl.textContent = body;
  }

  function renderGroups(gate, picker) {
    var mount = qs(gate, '[data-amc-diy-gate-groups]');
    var confirm = qs(gate, '[data-amc-diy-gate-confirm]');
    if (!mount) return;
    mount.textContent = '';
    visibleGroups(picker).forEach(function (el) {
      var options = collectGroupOptions(el);
      if (!options.length) return;
      var group = document.createElement('div');
      group.className = 'amc-diy-variant-gate__group';
      var legend = document.createElement('span');
      legend.className = 'amc-diy-variant-gate__legend';
      legend.textContent = groupName(el);
      var row = document.createElement('div');
      row.className = 'amc-diy-variant-gate__options';
      options.forEach(function (option) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'amc-diy-variant-gate__chip';
        if (option.image) chip.classList.add('has-image');
        if (option.selected) chip.classList.add('is-selected');
        if (!option.available) chip.classList.add('is-unavailable');
        chip.disabled = !option.available;
        if (option.image) {
          var img = document.createElement('img');
          img.src = option.image;
          img.alt = option.label;
          img.className = 'amc-diy-variant-gate__chip-image';
          chip.appendChild(img);
        }
        var name = document.createElement('span');
        name.className = 'amc-diy-variant-gate__chip-name';
        name.textContent = option.label;
        chip.appendChild(name);
        chip.addEventListener('click', function () {
          applyOption(option);
          window.setTimeout(function () {
            renderGroups(gate, getPicker());
            updateCopy(gate, getPicker());
            updateConfirm(gate, getPicker());
          }, 40);
        });
        row.appendChild(chip);
      });
      group.appendChild(legend);
      group.appendChild(row);
      mount.appendChild(group);
    });
    updateConfirm(gate, picker);
  }

  function updateConfirm(gate, picker) {
    var confirm = qs(gate, '[data-amc-diy-gate-confirm]');
    if (!confirm) return;
    confirm.disabled = missingGroups(picker).length > 0;
  }

  function openGate(action) {
    var gate = getGate();
    var picker = getPicker();
    if (!gate || !picker) return;
    pendingAction = action || 'atc';
    lastFocus = document.activeElement;
    updateCopy(gate, picker);
    renderGroups(gate, picker);
    gate.hidden = false;
    gate.classList.add('is-open');
    document.documentElement.classList.add('amc-diy-variant-gate-open');
    var dialog = qs(gate, '.amc-diy-variant-gate__dialog');
    var firstChip = qs(gate, '.amc-diy-variant-gate__chip:not(:disabled)');
    (firstChip || dialog).focus();
  }

  function closeGate(nudge) {
    var gate = getGate();
    var picker = getPicker();
    if (!gate) return;
    gate.classList.remove('is-open');
    gate.hidden = true;
    document.documentElement.classList.remove('amc-diy-variant-gate-open');
    if (nudge && picker && needsSelection()) {
      picker.classList.add('is-amc-diy-nudge');
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(function () {
        picker.classList.remove('is-amc-diy-nudge');
      }, 800);
    }
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    syncPayCatcher();
  }

  function findAtcButton() {
    var sectionId = getSectionId();
    return (
      qs(document, '#x-atc-button-' + sectionId) ||
      qs(document, '#product-form-' + sectionId + ' .add_to_cart_button')
    );
  }

  function findShopPayButton() {
    var sectionId = getSectionId();
    var box = qs(document, '#x-payment-button-' + sectionId);
    if (!box) return null;
    return (
      qs(box, 'shopify-accelerated-checkout') ||
      qs(box, '.shopify-payment-button button') ||
      qs(box, 'button')
    );
  }

  function proceed() {
    if (needsSelection()) return;
    closeGate(false);
    proceeding = true;
    waitForResolved(1800).then(function (ok) {
      if (!ok) {
        proceeding = false;
        return;
      }
      syncVariantIdFromSelection();
      syncPayCatcher();
      if (pendingAction === 'shop_pay') {
        var pay = findShopPayButton();
        if (pay) pay.click();
      } else {
        var atc = findAtcButton();
        if (atc) atc.click();
      }
      window.setTimeout(function () {
        proceeding = false;
      }, 50);
    });
  }

  function shouldHandleAtc(button) {
    if (!button || !button.classList.contains('add_to_cart_button')) return false;
    var root = getRoot();
    if (!root) return false;
    var sectionId = getSectionId();
    var form = button.closest('form[data-type="add-to-cart-form"]');
    if (!form || !sectionId) return false;
    return form.id.indexOf(sectionId) !== -1;
  }

  function onDocumentClick(event) {
    if (proceeding) return;

    var dismiss = event.target.closest('[data-amc-diy-gate-dismiss], [data-amc-diy-gate-change]');
    if (dismiss) {
      event.preventDefault();
      closeGate(true);
      return;
    }

    var confirm = event.target.closest('[data-amc-diy-gate-confirm]');
    if (confirm) {
      event.preventDefault();
      proceed();
      return;
    }

    var catcher = event.target.closest('[data-amc-diy-pay-catcher]');
    if (catcher) {
      event.preventDefault();
      event.stopPropagation();
      if (needsSelection()) openGate('shop_pay');
      return;
    }

    var atc = event.target.closest('.add_to_cart_button');
    if (!shouldHandleAtc(atc)) return;
    if (!needsSelection()) {
      if (!isResolved(getPicker())) {
        event.preventDefault();
        event.stopImmediatePropagation();
        pendingAction = 'atc';
        proceed();
      }
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    openGate('atc');
  }

  function onKeydown(event) {
    var gate = getGate();
    if (!gate || !gate.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeGate(true);
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = qsa(gate, 'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(
      function (el) {
        return el.offsetParent !== null;
      }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function unlockAtcButtons() {
    var sectionId = getSectionId();
    if (!sectionId) return;
    [
      '#x-atc-button-' + sectionId,
      '#x-atc-button-sticky-' + sectionId,
      '#product-form-' + sectionId + ' .add_to_cart_button',
      '#product-form-sticky-' + sectionId + ' .add_to_cart_button',
    ].forEach(function (sel) {
      qsa(document, sel).forEach(function (button) {
        if (button.dataset.available === 'false') return;
        button.removeAttribute('disabled');
      });
    });
  }

  function bindPicker(picker) {
    if (!picker || picker.dataset.amcDiyGateBound === 'true') return;
    picker.dataset.amcDiyGateBound = 'true';
    if (!missingGroups(picker).length) markResolved(picker, true);
    picker.addEventListener('change', function () {
      markResolved(picker, false);
      syncPayCatcher();
    });
  }

  function init() {
    var root = getRoot();
    var gate = getGate();
    if (!root || !gate) return;
    var picker = getPicker(root);
    var sectionId = getSectionId();
    bindPicker(picker);
    unlockAtcButtons();
    window.setTimeout(unlockAtcButtons, 0);
    window.setTimeout(unlockAtcButtons, 250);
    syncPayCatcher();
    document.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, function () {
      markResolved(getPicker(), true);
      syncPayCatcher();
      var openGateEl = getGate();
      if (openGateEl && openGateEl.classList.contains('is-open')) {
        renderGroups(openGateEl, getPicker());
        updateCopy(openGateEl, getPicker());
      }
    });
  }

  function onFormSubmit(event) {
    if (proceeding) return;
    var form = event.target;
    if (!form || !form.getAttribute) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
    var sectionId = getSectionId();
    if (!sectionId || form.id.indexOf(sectionId) === -1) return;
    if (!needsSelection()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openGate('atc');
  }

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('submit', onFormSubmit, true);
  document.addEventListener('keydown', onKeydown);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    i18n = null;
    init();
  });
})();
